function getCookie(name) {
  var cookieArr = document.cookie.split(";");
  for (var i = 0; i < cookieArr.length; i++) {
    var cookiePair = cookieArr[i].split("=");
    if (name == cookiePair[0].trim()) {
      return decodeURIComponent(cookiePair[1]);
    }
  }
  return null;
}

if (window.location.href.includes("return_url")) {
  let domainResp = "gazelle";
  let returnUrlResp = DIRECT_STORE_URL
  const [baseUrl, queryString] = window.location.href.split("?");
  let returnUrl = queryString.match(/return_url=(.*)/);
  if (returnUrl) {
    returnUrl = returnUrl[1];
    returnUrlResp = returnUrl;
    if (returnUrl.includes(SUBSCRIPTION_REACT_APP_URL)) {
      domainResp = "subscription"
    } else if (returnUrl.includes(TRADE_IN_STORE_URL)) {
      domainResp = "trade-in"
    }
  }
  const now = new Date();
  now.setTime(now.getTime() + 1 * 3600 * 1000); // 1 hour in milliseconds
  const expires = now.toUTCString();
  document.cookie = `Domain=${domainResp};expires=${expires};path=/;`;
  document.cookie = `ReturnUrl=${returnUrlResp};expires=${expires};path=/;`
}

function storeCookieByReturnUrl(url) {
  let domainResp = "gazelle";
  let returnUrlResp = DIRECT_STORE_URL
  if (url.includes("return_url")) {
    const [baseUrl, queryString] = url.split("?");
    let returnUrl = queryString.match(/return_url=(.*)/);
    if (returnUrl) {
      returnUrl = returnUrl[1];
      returnUrlResp = returnUrl;
      if (returnUrl.includes(SUBSCRIPTION_REACT_APP_URL)) {
        domainResp = "subscription"
      } else if (returnUrl.includes(TRADE_IN_STORE_URL)) {
        domainResp = "trade-in"
      }
    }
  }
  const now = new Date();
  now.setTime(now.getTime() + 1 * 3600 * 1000); // 1 hour in milliseconds
  const expires = now.toUTCString();
  document.cookie = `Domain=${domainResp};expires=${expires};path=/;`;
  document.cookie = `ReturnUrl=${returnUrlResp};expires=${expires};path=/;`
}

function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

function formatCurrency(number) {
  // Create our number formatter.
  var formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",

    // These options are needed to round to whole numbers if that's what you want.
    //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
  });

  formatter.format(number);
}

function loading(msg, parentElement) {
  let loading = document.createElement("div");
  let loadingMsg = 'Loading';
  if (typeof(msg) != 'undefined') {
    loadingMsg = msg;
  }
  loading.id = 'loading';
  loading.innerHTML = `
  <h4>${loadingMsg}</h4>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: 0; background: none; display: block; shape-rendering: auto;" width="500px" height="50px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
    <path d="M10 50A40 40 0 0 0 90 50A40 42 0 0 1 10 50" fill="#ff6900" stroke="none">
      <animateTransform attributeName="transform" type="rotate" dur="1s" repeatCount="indefinite" keyTimes="0;1" values="0 50 51;360 50 51"></animateTransform>
    </path>
  </svg>
  `;
  if (typeof(parentElement) != 'undefined') {
    document.querySelector(parentElement).appendChild(loading);
  }
  else {
    document.body.appendChild(loading);
  }
}
function removeLoading() {
  let loading = document.getElementById("loading");
  loading.parentNode.removeChild(loading);
}

// JWT function
function parseJwt(token) {
  const segments = token.split('.');
  if (segments.length !== 3) {
    return null;
  }
  const payload = JSON.parse(atob(segments[1]));

  return payload
}

const togglePassword = document.querySelector("#togglePassword");
const toggleResetPassword = document.querySelector("#toggleResetPassword");
const password = document.querySelector(".toggle-password");
const resetPassword = document.querySelector(".toggle-reset-password");

if (togglePassword != null) {
  togglePassword.addEventListener("click", function(e) {
    const type = password.getAttribute("type") === "password" ? "text" : "password";
    password.setAttribute("type", type);
    this.classList.toggle("eye-slash");
  });
}

if (toggleResetPassword != null) {
  toggleResetPassword.addEventListener("click", function(e) {
    const type = resetPassword.getAttribute("type") === "password" ? "text" : "password";
    resetPassword.setAttribute("type", type);
    this.classList.toggle("eye-slash");
  });
}

// Registration Code
const registerButton = document.querySelector(".btn-register");
if (registerButton != null) {
  registerButton.addEventListener("click", function(e) {
    e.preventDefault();
    const userName = document.querySelector("#Email");
    const passWord = document.querySelector("#CreatePassword");
    const firstName = document.querySelector("#FirstName");
    const lastName = document.querySelector("#LastName");
    if (ENABLE_CAPTCHA) {
      const captchaResponse = grecaptcha.getResponse();
      if(captchaResponse.length == 0) {
        document.getElementById('g-recaptcha-error').innerHTML = '<span style="color:red;">This field is required.</span>';
        return false;
      }
    }

    const data = {
      userName: userName.value,
      passWord: passWord.value,
      firstName: firstName.value,
      lastName: lastName.value,
    };

    if (data.userName && data.passWord && data.firstName && data.lastName) {
      if (userName.value.includes('<script>') || passWord.value.includes('<script>') || firstName.value.includes('<script>') || lastName.value.includes('<script>')) {
        let inputName = 'email';
        if (passWord.value.includes('<script>')) {
          inputName = 'password';
        } else if (firstName.value.includes('<script>')) {
          inputName = 'first name';
        } else if (lastName.value.includes('<script>')) {
          inputName = 'last name';
        }
        document.querySelector("#error").innerHTML = "You entered invalid " + inputName;
        document.querySelector(".error-message").style.display = "block"; 
      } else {
        localStorage.setItem("userName", data.userName);
        registerUser(data);
      }
    } else {
      document.querySelector("#error").innerHTML = "Please fill all fields";
      document.querySelector(".error-message").style.display = "block"; 
    }
  });
}

const registerUser = async (data) => {
  loading('Creating Your Account', ".user-account");
  const response = await axios.post(`${BASE_URL}/auth/sign-up`, data, {
    headers: {
      "x-api-key": `${SSO_API_KEY}`,
      "Content-Type": "application/json",
    }
  })
  .then((response) => {
    removeLoading();
    let redirectURL = "/account/register?emailverification="+data.userName;
    window.location.href = redirectURL;  

  })
  .catch((error) => {
    if(error.response){
      removeLoading();
      let errorMsg = error.response.data.error.message;
      switch (error.response.data.status) {
        case 459:
          errorMsg = "Password must have uppercase characters.";
        break;        
        case 465:
          errorMsg = "Must be a valid email address.";
        break;
        case 466:
          errorMsg = "Password length must be at least 8 characters long.";
        break;
        case 467:
          errorMsg = "Password must have symbol characters.";
        break;
        case 468:
          errorMsg = "Password must have numeric characters.";
        break;
        case 451:
          errorMsg = "Email is already being used. Please try logging in.";
        break;
        
      }
      document.querySelector("#error").innerHTML = errorMsg;
      document.querySelector(".error-message").style.display = "block";  
    }
  });
};

const verificationButton = document.querySelector(".verification-btn");
if (verificationButton != null) {
  verificationButton.addEventListener("click", function(e) {
    e.preventDefault();
    if (document.querySelector("#ConfirmationCode").value != '') {
      const data = {
        validationCode: document.querySelector("#ConfirmationCode").value
      };
      verifyUser(data);
    } 
    else {
      document.querySelector("#error").innerHTML = "Please Enter Confirmation Code";;
      document.querySelector(".error-message").style.display = "block";  
    }
  });
}

const verifyUser = async (data) => {
  var userName = getParameterByName('emailverification');
  
  const response = await axios.post(`${BASE_URL}/auth/sign-up/${userName}`, data, {
    headers: {
      "x-api-key": `${SSO_API_KEY}`,
      "Content-Type": "application/json",
    }
  })
  .then((response) => {
    loading('Loading', ".user-account");
    let redirectURL = `/account/login?accountcreated=${userName}`;
    window.location.href = redirectURL;  
  })
  .catch((error) => {
    if(error.response){
      let errorMsg = error.response.data.error.message;
      document.querySelector("#error").innerHTML = errorMsg;
      document.querySelector(".error-message").style.display = "block";  
    }
  });
};

const resendVerificationButton = document.querySelector(".verification-code a");
if (resendVerificationButton != null) {
  resendVerificationButton.addEventListener("click", function(e) {
    e.preventDefault();
    const resendVerificationEmail =  getParameterByName('emailverification') || document.querySelector(".verification-code input").value;
    if (resendVerificationEmail != '') {
      const data = {
        userName: resendVerificationEmail
      };
      resendVerificationCode(data);  
    }
  });
}

const resendVerificationCode = async (data) => {
  const response = await axios.post(`${BASE_URL}/auth/resend-confirmation-code`, data, {
    headers: {
      "x-api-key": `${SSO_API_KEY}`,
      "Content-Type": "application/json",
    }
  })
  .then((response) => {
    document.querySelector("#success").innerHTML = `Your email verification code was sent to ${data.userName}!`;
    document.querySelector(".error-message").style.display = "none";
    document.querySelector(".success-message").style.display = "block";  
  })
  .catch((error) => {
    let errorMessage = error.response ? error.response.data.error.message : ["Network Error"];
    document.querySelector("#error").innerHTML = errorMessage;
    document.querySelector(".error-message").style.display = "block";
  });
};

if (window.location.href.indexOf("emailverification") > -1) {
  document.getElementById("email-verification").style.display = "block";
  document.getElementById("create-customer").style.display = "none";
  if (getParameterByName('emailverification') != '') {
    document.querySelector(".resend-verification input").value = getParameterByName('emailverification');
  }
  else {
    document.querySelector(".resend-verification").style.display = "none";
  }
}

const resendCodeButton = document.querySelector(".resend-code a");
if (resendCodeButton != null) {
  resendCodeButton.addEventListener("click", function(e) {
    e.preventDefault();
    const resendCodeEmail = document.querySelector(".resend-code input").value;
    if (resendCodeEmail != '') {
      const data = {
        userName: resendCodeEmail
      };
      resendConfirmationCode(data);  
    }
  });
}

const resendConfirmationCode = async (data) => {
  const response = await axios.post(`${BASE_URL}/auth/forgot-password`, data, {
    headers: {
      "x-api-key": `${SSO_API_KEY}`,
      "Content-Type": "application/json",
    }
  })
  .then((response) => {
    document.querySelector("#success").innerHTML = `Your confirmation code was sent to ${data.userName}!`;
    document.querySelector(".error-message").style.display = "none";
    document.querySelector(".success-message").style.display = "block";  
  })
  .catch((error) => {
    let errorMessage = error.response ? error.response.data.error.message : ["Network Error"];
    if (Array.isArray(errorMessage)) {
      errorMessage = errorMessage[0];
    }
    document.querySelector("#error").innerHTML = errorMessage;
    document.querySelector(".error-message").style.display = "block";
  });
};

// Logout Code
const logoutLink = document.querySelector(".logout-link");
if (logoutLink != null) {
  logoutLink.addEventListener("click", function(e) {
    // calling GA4 Event
    let userEmail = `${customerEmail}` || "unspecified";
    let createdAt = "unspecified";
    const createAtfromCookie = getCookie('createdAt');
    if (createAtfromCookie) {
      createdAt = createAtfromCookie;
    }
    let userId = "unspecified";
    const accessToken = getCookie('accessToken');
    if (accessToken) {
      const parseAccessToken = parseJwt(accessToken);
      if (parseAccessToken) {
        userId = parseAccessToken.username
      }
    }
    (window.dataLayer = window.dataLayer || []).push({
        'event': 'page.user',
        'page.user': {
            'v': 13,
            'id': userId,
            'emails': userEmail,
            'regDate': parseInt(createdAt),
            'action':'logout'
        }
    });
    // Clear Cookie after logout
    document.cookie = `accessToken=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;domain=${DOMAIN_FOR_COOKIE};`;
    document.cookie = `customerAccessToken=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;domain=${DOMAIN_FOR_COOKIE};`;
    document.cookie = `user_email=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;domain=${DOMAIN_FOR_COOKIE};`;
    document.cookie = `createdAt=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;domain=${DOMAIN_FOR_COOKIE};`;
    document.cookie = `Domain=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;domain=${DOMAIN_FOR_COOKIE};`;
    document.cookie = `ReturnUrl=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;domain=${DOMAIN_FOR_COOKIE};`;
    let iframe = document.createElement('iframe');
    iframe.src = `${SUBSCRIPTION_SHOPIFY_STORE_URL}/account/logout`;
    iframe.height = 0;
    iframe.width = 0;
    document.body.appendChild(iframe);
    fetch("/account/logout");
    window.location.href = "/account/login";
  });
}


// Login Code
if (window.location.href.indexOf("session") > -1) {
  document.querySelector("#error").innerHTML = "Session expired. Please sign in again.";
  document.querySelector(".error-message").style.display = "block";
}
if (window.location.href.indexOf("login") > -1 && window.location.href.indexOf("accountcreated") > -1 ) {
  let email = getParameterByName('accountcreated');
  document.querySelector("#success").innerHTML = "Your account has been created!";
  document.querySelector(".success-message").style.display = "block";  
  document.getElementById("CustomerEmail").value = email;  
}
if (window.location.href.indexOf("login") > -1 && window.location.href.indexOf("passwordreset") > -1 ) {
  let email = getParameterByName('passwordreset');
  document.querySelector("#success").innerHTML = "Your password has been reset!";
  document.querySelector(".success-message").style.display = "block";
  document.getElementById("CustomerEmail").value = email;  
}

if (window.location.href.indexOf("/account/login?logout") > -1) {
  // Clear Cookie if user is trying to logged in
  document.cookie = `accessToken=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;domain=${DOMAIN_FOR_COOKIE};`;
  document.cookie = `customerAccessToken=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;domain=${DOMAIN_FOR_COOKIE};`;
  document.cookie = `user_email=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;domain=${DOMAIN_FOR_COOKIE};`;
  document.cookie = `createdAt=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;domain=${DOMAIN_FOR_COOKIE};`;
  let iframe = document.createElement('iframe');
  iframe.src = `${SUBSCRIPTION_SHOPIFY_STORE_URL}/account/logout`;
  iframe.height = 0;
  iframe.width = 0;
  document.body.appendChild(iframe);
  fetch("/account/logout");
  let returnUrlResp = DIRECT_STORE_URL
  if (window.location.href.includes("logout_return_url")) {
    const [baseUrl, queryString] = window.location.href.split("?");
    let returnUrl = queryString.match(/logout_return_url=(.*)/);
    returnUrlResp = returnUrl[1];
    returnUrlResp = decodeURIComponent(returnUrlResp);
  }
  window.location.href = returnUrlResp;
}

const loginButton = document.querySelector(".btn-login");
if (loginButton != null) {
  loginButton.addEventListener("click", function() {
    if (ENABLE_CAPTCHA) {
      const captchaResponse = grecaptcha.getResponse();
      if(captchaResponse.length == 0) {
       document.getElementById('g-recaptcha-error').innerHTML = '<span style="color:red;">This field is required.</span>';
       return false;
      }
    }
   
    const data = {
      userName: document.getElementById("CustomerEmail").value,
      passWord: document.getElementById("CustomerPassword").value,
    };

    if (data.userName && data.passWord) {
      handleLogin(data);
    }
    else {
      document.querySelector("#error").innerHTML = "Please fill all fields";
      document.querySelector(".error-message").style.display = "block";   
    }
  });
}

async function handleLogin(data) {
  loading('Logging in ...', ".user-account");
  let domain = getCookie("Domain");
  if (!domain) {
    storeCookieByReturnUrl(window.location.href);
    domain = getCookie("Domain");
  }
  let CookieReturnUrl = getCookie("ReturnUrl");
  let ReturnUrl = DIRECT_STORE_URL;
  let subscriptionReturnUrl = DIRECT_STORE_URL;
  if (domain == "trade-in") {
    ReturnUrl = CookieReturnUrl;
  } else if (domain == "subscription") {
    subscriptionReturnUrl = CookieReturnUrl;
  }
  data.returnUrl = ReturnUrl;
  data.subReturnUrl = subscriptionReturnUrl;
  document.querySelector(".error-message").style.display = "none"; 
  document.querySelector(".success-message").style.display = "none";  
  const response = await axios.post(`${BASE_URL}/auth/login`, data, {
    headers: {
      "x-api-key": `${SSO_API_KEY}`,
      "Content-Type": "application/json"
    }
  })
  .then((response) => {
    if (response.data.mergeAccount == true) {
      removeLoading();
      document.getElementById("MergeAccountForm").style.display = "block";
      document.getElementById("RecoverPasswordForm").style.display = "none";
      document.getElementById("CustomerLoginForm").style.display = "none";
    }
    else {
      let userId = "unspecified";
      let createdAt = "unspecified";
      if (response.data.createdAt) {
        createdAt = Math.floor(new Date(response.data.createdAt).getTime() / 1000);
      }
      if (response.data.accessToken) {
        const parseAccessToken = parseJwt(response.data.accessToken);
        if (parseAccessToken) {
          userId = parseAccessToken.username
        }
      }
      const now = new Date();
      now.setTime(now.getTime() + 8 * 3600 * 1000); // 8 hour in milliseconds
      const expires = now.toUTCString();
      // Add cookie Domain Level
      document.cookie = `accessToken=${response.data.accessToken};Domain=${DOMAIN_FOR_COOKIE};expires=${expires};path=/;`;
      document.cookie = `customerAccessToken=${response.data.customerAccessToken};Domain=${DOMAIN_FOR_COOKIE};expires=${expires};path=/;`;
      document.cookie = `user_email=${data.userName};Domain=${DOMAIN_FOR_COOKIE};expires=${expires};path=/;`;
      document.cookie = `createdAt=${createdAt};Domain=${DOMAIN_FOR_COOKIE};expires=${expires};path=/;`;

      // calling GA4 Event
      (window.dataLayer = window.dataLayer || []).push({
        'event': 'page.user',
        'page.user': {
            'v': 13,
            'id': userId,
            'emails': data.userName,
            'regDate': createdAt,
            'action':'login'
        }
      });
      // redirect here 
      let domain = getCookie("Domain");
      let firstRedirectUrl = response.data.subRedirectUrl;
      let secondRedirectUrl = response.data.redirecturl;
      if (domain === "subscription") {
        firstRedirectUrl = response.data.redirecturl;
        secondRedirectUrl = response.data.subRedirectUrl;
      }
      // Create a new iframe element.
      const iframe = document.createElement('iframe');
      iframe.src = firstRedirectUrl;
      iframe.height = 100;
      iframe.width = 100;
      
      // Add the iframe element to the DOM.
      document.body.appendChild(iframe);
      
      // Set a timeout to change the location href after 3 seconds.
      setTimeout(() => {
        document.cookie = `Domain=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
        document.cookie = `ReturnUrl=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
        window.location.href = secondRedirectUrl;
      }, 3000);
    }
  })
  .catch((error) => {
    removeLoading();
    document.querySelector("#error").innerHTML = "We didn't recognize your email or password. Please try again.";
    document.querySelector(".error-message").style.display = "block"; 
    document.querySelector(".success-message").style.display = "none";  
  });
}

const sendEmail = document.querySelector("#send-email");
if (sendEmail != null) {
  sendEmail.addEventListener("click", function() {
    resendEmail();
  });
}
function resendEmail() {
  if (document.getElementById("CustomerEmail").value != "" || document.getElementById("RecoverEmail").value != "") {
    let customerEmail = document.getElementById("CustomerEmail").value;
    if (document.getElementById("RecoverEmail").value != "") {
      customerEmail = document.getElementById("RecoverEmail").value;
    }
    const data = {
      userName: customerEmail,
      mergeAccount: true
    }
    handleMergeAccount(data);
  }
}

async function handleMergeAccount(data) {
  loading('Sending Email ...', ".user-account");
  const response = await axios.post(`${BASE_URL}/auth/login`, data, {
    headers: {
      "x-api-key": `${SSO_API_KEY}`,
      "Content-Type": "application/json",
    }
  })
  .then((response) => {
      window.location.href = "/account/login?resetpassword="+data.userName; 
  })
  .catch((error) => {
    removeLoading();
    if(error.response){
      let errorMsg = error.response.data.error.message;
      document.querySelector("#error").innerHTML = errorMsg;
      document.querySelector(".error-message").style.display = "block";  
    }
  });      
}


// Forgot Password
if (window.location.href.indexOf("forgotpassword") > -1) {
  document.getElementById("RecoverPasswordForm").style.display = "block";
  document.getElementById("CustomerLoginForm").style.display = "none";
  document.querySelector(".resend-code").style.display = "none";
  document.querySelector(".error-message").style.display = "none";
}

const forgot_password = document.querySelector("#forgot-password");
if (forgot_password != null) {
  forgot_password.addEventListener("click", function() {
    let recoverEmail = document.querySelector("#RecoverEmail").value;
    if (recoverEmail != "") {
      const data = {
        userName: recoverEmail,
      };
      handleForgotPassword(data);
    }
    else {
      document.querySelector("#error").innerHTML = "Email field is required";;
      document.querySelector(".error-message").style.display = "block";            
    }
  });
}

// Reset Password
if (window.location.href.indexOf("resetpassword") > -1) {

  if (window.location.href.indexOf("resendcode") > -1) {
    resendCodeEmail = getParameterByName('resendcode');
    document.getElementById("RecoverEmail").value = resendCodeEmail;
    document.getElementById("RecoverEmail").disabled = true;
    const data = {
      userName: resendCodeEmail,
    };
    handleForgotPassword(data) 
  }
  else {
    resendCodeEmail = getParameterByName('resetpassword');
    document.getElementById("RecoverEmail").value = resendCodeEmail; 
    document.getElementById("RecoverEmail").disabled = true;
  }
  if (document.querySelector(".resend-code input") != null) {
    document.querySelector(".resend-code input").value = resendCodeEmail; 
  }
  if (document.querySelector(".resend-verification input") != null) {
    document.querySelector(".resend-verification input").value = resendCodeEmail; 
  }
  document.getElementById("RecoverPasswordForm").style.display = "inline-block";
  document.getElementById("CustomerLoginForm").style.display = "none";
  document.getElementById("ResetPasswordRule").style.display = "inline-block";
  document.querySelector(".reset-code").style.display = "inline-block";
  document.querySelector(".reset-password").style.display = "inline-block";
  document.querySelector(".recover-password-title").innerHTML = "Change Password";
  document.querySelector(".recover-password-text").innerHTML = "Enter in your new password below. Please use 8 or more characters of letters, numbers, and symbols. ";
  document.getElementById("back-to-login").style.display = "none";
  document.getElementById("reset-password").style.display = "inline-block";
  document.getElementById("forgot-password").style.display = "none";
}

async function handleForgotPassword(data) {
  loading('Updating ...', ".user-account");
  const response = await axios.post(`${BASE_URL}/auth/forgot-password`, data, {
    headers: {
      "x-api-key": `${SSO_API_KEY}`,
      "Content-Type": "application/json",
    }
  })
  .then((response) => {
    if (response.data.mergeAccount == true) {
      removeLoading();
      document.getElementById("MergeAccountForm").style.display = "block";
      document.getElementById("RecoverPasswordForm").style.display = "none";
      document.getElementById("CustomerLoginForm").style.display = "none";
    }
    else {
      window.location.href = `/account/login?resetpassword=${data.userName}`;
    }
  })
  .catch((error) => {
    removeLoading();
    let errorMsg = `We didn't recognize that email. Please try again.`;
    // if (error.response.data.status == 459 || error.response.data.status == 453) {
    //   errorMsg += `<a href="javascript:resendEmail();">Resend Code</a>`;
    // }
    document.querySelector("#error").innerHTML = errorMsg;
    document.querySelector(".error-message").style.display = "block";  
  });
}


const reset_password = document.querySelector("#reset-password");
if (reset_password != null) {
  reset_password.addEventListener("click", function() {
    loading('Updating ...', ".user-account");
    const data = {
      userName: document.querySelector("#RecoverEmail").value,
      passWord: document.querySelector("#ResetPassword").value,
      confirmationCode: document.querySelector("#ConfirmationCode").value
    };
    if (data.userName != "" && data.passWord != "" && data.confirmationCode != "") {
      handlePasswordConfirmationCode(data);
    }
    else {
      removeLoading();
      document.querySelector("#error").innerHTML = "All field are required";
      document.querySelector(".error-message").style.display = "block";  
    }  
  });
}

async function handlePasswordConfirmationCode(data) {
  const response = await axios.post(`${BASE_URL}/auth/confirm-forgot-password`, data, {
    headers: {
      "x-api-key": `${SSO_API_KEY}`,
      "Content-Type": "application/json",
    }
  })
  .then((response) => {
    window.location.href = `/account/login?passwordreset=${data.userName}`;
  })
  .catch((error) => {
    removeLoading();
    let errorMsg = error.response.data.error.message;
    document.querySelector("#error").innerHTML = errorMsg;
    document.querySelector(".error-message").style.display = "block";
  });
}

const filterAll = document.querySelector("#filter-all");
const filterPurchases = document.querySelector("#filter-purchases");
const filterTrades = document.querySelector("#filter-trades");
const filterSubscriptions = document.querySelector("#filter-subscriptions");
if (filterAll != null) {
  filterAll.addEventListener("click", function(e) {
    renderTransactionHistory(customerEmail, "");
  });
}
if (filterPurchases != null) {
  filterPurchases.addEventListener("click", function(e) {
    renderTransactionHistory(customerEmail, "Shopify");
  });
}
if (filterTrades != null) {
  filterTrades.addEventListener("click", function(e) {
    renderTransactionHistory(customerEmail, "TradeIn");
  });
}
if (filterSubscriptions != null) {
  filterSubscriptions.addEventListener("click", function(e) {
    renderTransactionHistory(customerEmail, "Subscription");
  });
}

const getTransactionHistory = async (data) => {
  const response = await axios.get(`${BASE_URL}/auth/order-history/${data}`, {
    headers: {
      "x-api-key": `${SSO_API_KEY}`,
      "Content-Type": "application/json",
    }
  })
  .catch((error) => {
    console.log(error.response);
  });
  return response.data.data;
};
const renderTransactionHistory = async (data, filterby) => {
  const accessToken = getCookie('accessToken');
  if (accessToken) {
    let transactions = await getTransactionHistory(data);
    let transactionHistory = document.querySelector(".transaction-history");
    let noTransactionHistory = document.querySelector(".no-transaction-history");
    let transactionHistoryHeader = document.querySelector(
      ".transaction-history-header"
    );
    let transactionFilter = document.querySelectorAll(
      ".transaction-filter label"
    );
  
    transactionHistory.innerHTML = "";
  
    if (transactions.length > 0) {
      transactionHistory.style.display = "block";
      noTransactionHistory.style.display = "none";
      transactionHistoryHeader.style.display = "block";
  
      for (i = 0; i < transactionFilter.length; ++i) {
        transactionFilter[i].classList.remove("disabled");
      }
    } else {
      noTransactionHistory.style.display = "block";
      return;
    }
  
    for (let transaction in transactions) {
      if (transactions[transaction].orderType == filterby || filterby == "") {
        var e = document.createElement("div");
        var transactionRow = "";
        var detailButton = "";
        if (
          transactions[transaction].orderType == "Shopify" &&
          typeof transactions[transaction].shopifyOrderId != "undefined"
        ) {
          detailButton = `<div class="flexbox-table-row-item ord-view-div"><a href="javascript:renderOrderDetails('${transactions[transaction].shopifyOrderId}');">View Order</a></div>`;
        } else if (transactions[transaction].orderType == "Subscription") {
          detailButton = `<div class="flexbox-table-row-item ord-view-div"><a href=${RECHARGE_PORTAL_URL}>View Rental</a></div>`;
        } else {
          detailButton = `<div class="flexbox-table-row-item ord-view-div"><a href="javascript:renderTradeInDetails('${transactions[
            transaction
          ].orderNumber.trim()}');">View Trade</a></div>`;
        }
        transactionRow = `
        <li class="flexbox-table-row transaction-item">
        <div class="flexbox-table-row-item img-div"><img src="${transactions[transaction].imageUrl}"></div>
        <div class="flexbox-table-row-item ord-num-div"><label>Order -&nbsp;</label>${transactions[transaction].orderNumber}</div>
        <div class="flexbox-table-row-item ord-date-div"><label>Date -&nbsp;</label>${transactions[transaction].date}</div>
        <div class="flexbox-table-row-item ord-pay-div"><label>Order Status -&nbsp;</label>${transactions[transaction].orderStatus}</div>
        <div class="flexbox-table-row-item ord-stat-div"><label>Payment Status -&nbsp;</label>${transactions[transaction].paymentStatus}</div>
        <div class="flexbox-table-row-item ord-total-div"><label>Total -&nbsp;</label>$${transactions[transaction].amount}</div>
        ${detailButton}
        </li> 
        `;
        e.innerHTML = transactionRow;
        while (e.firstChild) {
          transactionHistory.appendChild(e.firstChild);
        }
      }
      setTimeout(function() {
        $(".transaction-item").paginate(10);
      }, 500);
    }
  } else {
    window.location.href = "account/login?logout";
  }
};

const renderOrderDetails = async (orderNumber) => {
  let lineItemRow = "";
  let taxLinesRow = "";
  let trackingRow = "";
  let returnURL = "";
  let trackingNumber = "";
  let trackingUrl = "";
  let carrierName = "";
  let fulfilledDate = "Unfulfilled";
  let orderDetails = await getOrderDetails(orderNumber);
  if (typeof orderDetails.order.fulfillments[0] != "undefined") {
    fulfilledDate = orderDetails.order.fulfillments[0].created_at;
    trackingNumber = orderDetails.order.fulfillments[0].tracking_number;
    trackingUrl = orderDetails.order.fulfillments[0].tracking_url;
    carrierName = orderDetails.order.fulfillments[0].tracking_company;
    if (typeof(trackingNumber) != "undefined" && typeof(trackingUrl) != "undefined") {
      trackingRow = `<li>Tracking Number - <a class="tracking-number" href="${trackingUrl}" target="_blank">${trackingNumber}</a></li>`;
    }
    returnURL = `<a class="return-btn" href="${RETURNLY_URL}/?order=${orderDetails.order.name}&zip=${orderDetails.order.shipping_address.zip}">Return</a>`;  
  }

  let lineItems = orderDetails.order.line_items;
  for (lineItem in lineItems) {
    lineItemRow += `
        <div class="flexbox-table-row order-items">
            <img class="line-item-image" src="${lineItems[lineItem].src}">
            <div class="line-item">
            <div class="line-item-header">
                <span>${lineItems[lineItem].name}</span>
            </div>
            <div class="line-item-details">
                <div class="column-1">
                <ul>
                    <li>SKU - ${lineItems[lineItem].sku}</li>
                    <li>Price - $${lineItems[lineItem].price}</li>
                    <li>Quantity - ${lineItems[lineItem].quantity}</li>
                </ul>
                </div>
                <div class="column-2">
                <ul>
                    <li>Date fulfilled - ${fulfilledDate}</li>
                    <li>Carrier - ${carrierName}</li>
                    ${trackingRow}
                </ul>
                </div>
                <div class="column-3">
                <div class="line-item-price">Total - $${lineItems[lineItem].price}</div>
                ${returnURL}
                </div>
            </div>
            </div>
        </div>
        `;
    let taxLines = orderDetails.order.tax_lines;

    for (taxLine in taxLines) {
      taxLinesRow += `
                <div class="flexbox-table-row order-totals">
                    <div>Tax (${taxLines[taxLine].title} ${taxLines[taxLine].rate * 100}%)</div>
                    <div>$${taxLines[taxLine].price}</div>
                </div>
            `;
    }
  }
  orderContent = `
        <div class="order-details row">
            <div class="col-sm-9">
                <div class="flexbox-table">
                    <div class="flexbox-table-header">
                        <div class="flexbox-table-header-item ordername">Order# ${
                          orderDetails.order.name
                        }</div>
                        <div class="flexbox-table-header-item orderdate">${
                          orderDetails.order.created_at
                        }</div>
                    </div>
                    ${lineItemRow}
                    <div class="flexbox-table-row order-subtotal">
                        <div>Subtotal</div>
                        <div>$${orderDetails.order.total_line_items_price}</div>
                    </div>
                    <div class="flexbox-table-row order-totals">
                        <div>Discount</div>
                        <div>$${orderDetails.order.total_discounts}</div>
                    </div>
                    ${taxLinesRow}
                    <div class="flexbox-table-row order-total order-total">
                        <div>Total USD</div>
                        <div>$${orderDetails.order.total_price}</div>
                    </div>
                </div>
            </div>
            <div class="col-sm-3 address-block">    
                <div class="content-block">
                    <h3>Billing Address</h3>
                    <p>${orderDetails.order.billing_address.name}<br>${
    orderDetails.order.billing_address.company ?? ""
  }<br>${orderDetails.order.billing_address.address1}, ${
    orderDetails.order.billing_address.address2
  }<br>${orderDetails.order.billing_address.city}, ${
    orderDetails.order.billing_address.province_code
  } ${orderDetails.order.billing_address.zip}<br>${
    orderDetails.order.billing_address.country
  }</p>
                </div>
                <br/>
                <div class="content-block">
                    <h3>Shipping Address</h3>
                    <p>${orderDetails.order.shipping_address.name}<br>${
    orderDetails.order.shipping_address.company ?? ""
  }<br>${orderDetails.order.shipping_address.address1}, ${
    orderDetails.order.shipping_address.address2
  }<br>${orderDetails.order.shipping_address.city}, ${
    orderDetails.order.shipping_address.province_code
  } ${orderDetails.order.shipping_address.zip}<br>${
    orderDetails.order.shipping_address.country
  }</p>
                </div>
            </div>
        </div>    
    `;
  document.querySelector(".transaction-details").innerHTML = orderContent;
  document.querySelector(".transaction-filter").style.display = "none";
  document.querySelector(".transaction-list").style.display = "none";
  document.querySelector(".back-to-transactions").style.display = "block";
  document.querySelector(".transaction-details").style.display = "block";
};

const renderTradeInDetails = async (orderNumber) => {
  let tradeContent = "";
  let tradeDetails = await getOrderDetails(orderNumber);
  for (trade in tradeDetails.packingSlipDataList) {
    if (tradeDetails.packingSlipDataList[trade].srsList == null) {
      return;
    }  
    let tradeRow = "";
    let srsList = tradeDetails.packingSlipDataList[trade].srsList;
    let showResend = false;
    for (srs in srsList) {
      let payoutTotal = srsList[srs].estimatedTotal;

      if (srsList[srs].payoutTotal != "") {
        payoutTotal = srsList[srs].payoutTotal;
      }

      
      const srStatus = ['declined', 'inspected', 'received', 'accepted', 'awaiting confirmation'];
      if (!srStatus.includes(srsList[srs].srStatus.toLowerCase())) {
          showResend = true;        
      }
      tradeRow += `
            <div class="flexbox-table-row order-items">
                <img class="line-item-image" src="${
                  srsList[srs].productImageUrl
                }">
                <div class="line-item">
                    <div class="line-item-header">
                        <span>${srsList[srs].productName}</span>
                    </div>
                    <div class="line-item-details">
                        <div class="column-1">
                        <ul>
                            <li>Status - ${srsList[srs].srStatus}</li>
                            <li>Offer Expires - ${
                              srsList[srs].expirationDate
                            }</li>
                            <li>Offer - $${payoutTotal}</li>
                        </ul>
                        </div>
                    </div>
                </div>
            </div>
            `;
    }

    let numItems =
      tradeDetails.packingSlipDataList[trade].srsList.length + " item";
    if (tradeDetails.packingSlipDataList[trade].srsList.length > 1) {
      numItems =
        tradeDetails.packingSlipDataList[trade].srsList.length + " items";
    }
    let tradeBonus = '';
    if (tradeDetails.packingSlipDataList[trade].bonusTotal != "0.00") {
      tradeBonus = `
      <div class="flexbox-table-row order-total">
        <div>Amazon.com Gift Card Bonus</div>
        <div>$${
          tradeDetails.packingSlipDataList[trade]
            .bonusTotal
        }</div>
      </div>`;
    }

    let cancelBox = '';
    if (tradeDetails.packingSlipDataList[trade].canCancelBox == true) {
      cancelBox = `<a class="cancel-box-btn" href="javascript:cancelBox('${tradeDetails.packingSlipDataList[trade].psNumber}');">Cancel this box</a>`;
    }
    const tradeStatus = ['created', 'completed', 'cancelled'];
    let tradeDetailContent = '';
    if (tradeStatus.includes(tradeDetails.packingSlipDataList[trade].psStatus.toLowerCase()) == false && showResend == true) {
      if (
        tradeDetails.packingSlipDataList[trade].trackingNumber != null && 
        tradeDetails.packingSlipDataList[trade].trackingNumber != ""
        ) {
        tradeDetailContent = `
        <div class="flexbox-table-row" style="justify-content:space-between;align-items:start;flex-direction: column;height: auto;">
        <div style="padding:0 20px;width: 100%;display: flex;justify-content: space-between;align-items: center;">
        <div style="font-family: 'Brandon Grotesque Medium';color:#000;">Your box has ${numItems}</div>
        ${cancelBox}
        </div>
        <div style="padding:0 20px;">
        <p>We're waiting to receive the box you created on ${tradeDetails.packingSlipDataList[trade].createdAt}</p>
        <p class="shipping-actions"><a href="javascript:download('${tradeDetails.packingSlipDataList[trade].shippingLabelUrl}', '${tradeDetails.packingSlipDataList[trade].psNumber}')" style="padding:5px 20px 5px 0;">Download shipping label</a><a href="javascript:resendShippingKit('${tradeDetails.packingSlipDataList[trade].psNumber}');" style="padding:5px 20px 5px 0;">Email Shipping Label with Instructions</a></p>
        <div style="font-family: 'Brandon Grotesque Medium';color:#000;">Shipment Tracking Number</div>
        <p><a href="${tradeDetails.packingSlipDataList[trade].trackingUrl}" style="padding:20px 20px 20px 0;">${tradeDetails.packingSlipDataList[trade].trackingNumber}</a></p>
        </div></div>`;
      }
      else {
        tradeDetailContent = `
        <div class="flexbox-table-row" style="justify-content:space-between;align-items:start;flex-direction: column;height: auto;">
        <div style="padding:20px;">
        <div style="font-family: 'Brandon Grotesque Medium';color:#000;">Your box has ${numItems}</div>
        <p>We're generating your shipping kit and will send it to ${customerEmail}</p>
        </div></div>`;
      }
    }

    tradeContent = `
            <div class="order-details row">
                <div class="col-sm-9">
                    <div class="flexbox-table">
                        <div class="flexbox-table-header">
                            <div class="flexbox-table-header-item ordername">Order - ${
                              tradeDetails.packingSlipDataList[trade].psNumber
                            }</div>
                            <div class="flexbox-table-header-item orderdate">Created - ${tradeDetails.packingSlipDataList[trade].createdAt}</div>
                        </div>
                        <div class="statusMessage" style="border:1px solid #ccc;">
                          <div class="error-message" style="display:none;">
                              <p id="error"></p>
                          </div>
                          <div class="success-message" style="display:none;">
                              <p id="success"></p>
                          </div>
                        </div>
                        ${tradeDetailContent}
                        ${tradeRow}
                        ${tradeBonus}
                        <div class="flexbox-table-row order-total">
                            <div>Estimated Payment</div>
                            <div>$${
                              tradeDetails.packingSlipDataList[trade]
                                .estimatedTotal
                            }</div>
                        </div>   
                    </div>
                </div>
                <div class="col-sm-3 address-block">    
                </div>
            </div>    
        `;
  }
  document.querySelector(".transaction-details").innerHTML = tradeContent;
  document.querySelector(".transaction-filter").style.display = "none";
  document.querySelector(".transaction-list").style.display = "none";
  document.querySelector(".back-to-transactions").style.display = "block";
  document.querySelector(".transaction-details").style.display = "block";
};

const getOrderDetails = async (orderNumber) => {
  const response = await axios.get(`${BASE_URL}/auth/order-details/${orderNumber}`);
  const responseData = response.data;
  return responseData.data;
};

function showTransactionHistory() {
  document.querySelector(".transaction-filter").style.display = "block";
  document.querySelector(".transaction-list").style.display = "block";
  document.querySelector(".back-to-transactions").style.display = "none";
  document.querySelector(".transaction-details").style.display = "none";
}

const getActionHistory = async (data) => {
  const response = await axios.get(
    `${BASE_URL}/auth/get-action-history/${data}`
  );
  const responseData = response.data;
  return responseData.data;
};

const renderActionHistory = async (data) => {
  let actionHistoryList = "";
  let actionHistory = await getActionHistory(data);
  let actionEmail = data;
  let psList = actionHistory.psList;
  for (let ps in psList) {
    actionHistoryList += `
        <div class="action-items">
        <div>${psList[ps].srsList[0].holdDescription}</div>
        <form name="member_signup" action="https://${TRADE_IN_STORE_URL}/omnilogin/track" method="post">
            <input name="email" type="hidden" value="${actionEmail}" />
            <input name="tracking_number" type="hidden" value="${psList[ps].srsList[0].psNumber}" />
            <input name="commit" type="hidden" value="Continue" />
            <input type="submit" value="Correct It" class="btn btn-link" style="font-size:14px;" />
        </form>
        </div>
        `;
  }
  if (actionHistoryList != "") {
    document.querySelector(
      ".action-history"
    ).innerHTML = `<div style="margin: 18px 5px;font-size:14px;font-weight:bold;">You need to take action on the following items:</div>${actionHistoryList}`;
  }
};

const cancelBox = async (data) => {
  const response = await axios.delete(`${BASE_URL}/auth/srapi-cancelbox/${data}`, data, {
    headers: {
      "x-api-key": `${SSO_API_KEY}`,
      "Content-Type": "application/json",
    }
  })
  .then((response) => {
    successMsg = "";
    if (response.data.message == "Sucessfully Deleted") {
      successMsg = "Your box has successfully cancelled"
    }
    document.querySelector("#success").innerHTML = successMsg;
    document.querySelector(".success-message").style.display = "block";
  });
};
const resendShippingKit = async (ordernum) => {
  const data = {
    orderNumber: ordernum
  }
  const response = await axios.post(`${BASE_URL}/auth/post-packing-slip-email`, data, {
    headers: {
      "x-api-key": `${SSO_API_KEY}`,
      "Content-Type": "application/json",
    }
  })
  .then((response) => {
    console.log(response);
    document.querySelector("#success").innerHTML = response.data.message;
    document.querySelector(".success-message").style.display = "block";
  });
};
const download = async (urlPath, fileName) => {
  const response = await axios.get(`${urlPath}`, {
    responseType: 'arraybuffer'
  })
  .then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${fileName}.gif`); //or any other extension
    document.body.appendChild(link);
    link.click();
  });
};
const setCustomerName = async (data) => {
  const response = await axios.post(`${BASE_URL}/auth/update-profile-name`, data, {
    headers: {
      "x-api-key": `${SSO_API_KEY}`,
      "Content-Type": "application/json",
    }
  })
  .then((response) => {
    let redirectURL = "/account";
    window.location.href = redirectURL;
  })
  .catch((error) => {
    console.log(error.response);
  });
};

const saveName = document.querySelector(".save-name");
if (saveName != null) {
  saveName.addEventListener("click", function(e) {
    let firstName = document.getElementById("UserFirstName");
    let lastName = document.getElementById("UserLastName");
    let data = {
      userName: customerEmail,
      firstName: firstName.value,
      lastName: lastName.value,
    };
    setCustomerName(data);
  });
}

const getNewsletter = async (data) => {
  const response = await axios.get(`${BASE_URL}/auth/get-newsletters/${data}`);
  const responseData = response.data;
  return responseData.data;
};

const renderNewsletter = async (data) => {
  let newsletterList = "";
  let newsletters = await getNewsletter(data);
  let newsletterKeys = Object.keys(newsletters);
  for (let newsletter in newsletterKeys) {
    if (newsletterKeys[newsletter] == "shopifyNewsletter") {
      newsletterList += `
                <div class="gazelle-buy-newsletter">
                    <input type="checkbox" name="gazelle-buy-subscribe" id="gazelle-buy-subscribe">
                    <div>
                        <h4>Gazelle Buy Email Promotion</h4>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                    </div>
                </div>
            `;
    }
    if (newsletterKeys[newsletter] == "gazelleNewsletter") {
      newsletterList += `
            <div class="gazelle-sell-newsletter">
                <input type="checkbox" name="gazelle-sell-subscribe" id="gazelle-sell-subscribe">
                <div>
                    <h4>Gazelle Sell Email Promotion</h4>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                </div>
            </div>    
            `;
    }
  }
  if (document.querySelector(".edit-notification-list") != null) {
    document.querySelector(".edit-notification-list").innerHTML = newsletterList;
  }
};

const setNotifications = async (data) => {
  const response = await axios.post(`${BASE_URL}/auth/update-newsletters`, data, {
    headers: {
      "x-api-key": `${SSO_API_KEY}`,
      "Content-Type": "application/json",
    }
  })
  .then((response) => {
    let redirectURL = "/account";
    window.location.href = redirectURL;
  })
  .catch((error) => {
    console.log(error.response);
  });
};

const saveNotifications = document.querySelector(".save-notifications");
if (saveNotifications != null) {
  saveNotifications.addEventListener("click", function(e) {
    let subscribeBuy = false;
    let subscribeSell = false;
    if (document.getElementById("gazelle-buy-subscribe") != null) {
      subscribeBuy = document.getElementById("gazelle-buy-subscribe").checked;
    }
    if (document.getElementById("gazelle-sell-subscribe") != null) {
      subscribeSell = document.getElementById("gazelle-sell-subscribe").checked;
    }

    let data = {
      userName: customerEmail,
      shopifyNewsletter: subscribeBuy,
      gazelleNewsletter: subscribeSell,
    };
    setNotifications(data);
  });
}

if (
  window.location.href.indexOf("account") > -1 &&
  window.location.href.indexOf("register") == -1 &&
  window.location.href.indexOf("login") == -1
) {
  if (window.location.href.indexOf("tradein") > -1) {
    document.getElementById("filter-trades").checked = true;
    renderTransactionHistory(customerEmail, "TradeIn");
  }
  else {
    renderTransactionHistory(customerEmail, "");
  }
  renderActionHistory(customerEmail);
}
document.body.addEventListener("keyup", function(event) {
  if (event.keyCode === 13) {
    event.preventDefault();
    if (document.querySelector(".btn-login") != null && document.querySelector("#CustomerLoginForm").style.display != "none") {
      document.querySelector(".btn-login").click();
    }
    if (document.querySelector(".btn-register") != null && document.querySelector(".btn-register").style.display != "none" && document.querySelector("#create-customer").style.display != "none") {
      document.querySelector(".btn-register").click();
    }    
    if (document.querySelector(".verification-btn") != null && document.querySelector(".verification-btn").style.display != "none" && document.querySelector("#email-verification").style.display != "none") {
      document.querySelector(".verification-btn").click();
    }        
    if (document.querySelector("#forgot-password") != null && document.querySelector("#forgot-password").style.display != "none" && document.querySelector("#RecoverPasswordForm").style.display != "none") {
      document.querySelector("#forgot-password").click();
    }    
    if (document.querySelector("#reset-password") != null && document.querySelector("#reset-password").style.display != "none" && document.querySelector("#RecoverPasswordForm").style.display != "none") {
      document.querySelector("#reset-password").click();
    }    
  }
});